export { default } from "./CouponInformation";
